import { Component, ViewEncapsulation, OnInit } from '@angular/core';


import {
	Router, NavigationStart, NavigationEnd,
	NavigationCancel, NavigationError, Event
} from '@angular/router';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AppComponent {
	title = 'UIK-Framework';

	showLoadingIndicator = true;

	constructor(private _router: Router) {
		// Subscribe to the router events observable
		this._router.events.subscribe((routerEvent: Event) => {

			// On NavigationStart, set showLoadingIndicator to ture
			if (routerEvent instanceof NavigationStart) {
				this.showLoadingIndicator = true;
			}

			// On NavigationEnd or NavigationError or NavigationCancel
			// set showLoadingIndicator to false
			if (routerEvent instanceof NavigationEnd ||
				routerEvent instanceof NavigationError ||
				routerEvent instanceof NavigationCancel) {
				this.showLoadingIndicator = false;
			}

		});
	}

	public ngOnInit() {

	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts